/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2025-12-19 13:59:49 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-02-27 14:18:08 +0800
 * @FilePath     : /ai-agent-lumina/src/directives/index.js
 * @Description  : 注册指令
 */
import imgSrc from './img-src'
import scrollTop from './scroll-top'

const directives = {
  imgSrc,
  scrollTop
}

export default {
  install(app) {
    Object.entries(directives).forEach(([name, directive]) => {
      app.directive(name, directive)
    })
  }
}